var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CInfoPageTemplate,{attrs:{"content-label":'留言须知',"content-text":_setup.config.leaveWordTips,"button-text":'立即留言'},on:{"button-click":_setup.goLeaveWord}})
}
var staticRenderFns = []

export { render, staticRenderFns }